import { render, staticRenderFns } from "./ServiceSingleView.vue?vue&type=template&id=76d93916&"
import script from "./ServiceSingleView.vue?vue&type=script&lang=js&"
export * from "./ServiceSingleView.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSingleView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d93916')) {
      api.createRecord('76d93916', component.options)
    } else {
      api.reload('76d93916', component.options)
    }
    module.hot.accept("./ServiceSingleView.vue?vue&type=template&id=76d93916&", function () {
      api.rerender('76d93916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/ServiceSingleView.vue"
export default component.exports